import React, { useEffect, useState } from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import {
  FaRegCalendarCheck,
  FaCalendarWeek,
  FaCalendarAlt,
} from "react-icons/fa";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import featureService from "../api/services/dashbaordService";
import Loading from "../components/Loading";
import userServices from "../api/services/userService";

ChartJS.register(ArcElement, Tooltip, Legend);
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Home = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showTodayUsersModal, setShowTodayUsersModal] = useState(false);
  const [showMonthUsersModal, setShowMonthUsersModal] = useState(false);
  const [todayUsers, setTodayUsers] = useState([]);
  const [monthUsers, setMonthUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;

  useEffect(() => {
    document.body.style.overflowX = 'hidden';
    return () => {
      document.body.style.overflowX = '';
    };
  }, []);

  useEffect(() => {
    // Disable body scroll when modals are open
    if (showTodayUsersModal || showMonthUsersModal) {
      document.body.style.overflow = 'hidden';
      document.body.style.overflowX = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.body.style.overflowX = 'hidden';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [showTodayUsersModal, showMonthUsersModal]);
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const result = await featureService.fetchAll();
        console.log("Dashboard data:", result);
        if (result?.responseCode === 200) {
          setDashboardData(result);
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleTodayUsersClick = async () => {
    try {
      const result = await userServices.fetchAllUsers(1);
      if (result?.users) {
        const count = usersAnalytics?.today || 10;
        setTodayUsers(result.users.slice(0, count));
      }
      setCurrentPage(1);
      setShowTodayUsersModal(true);
    } catch (error) {
      console.error("Error fetching today users:", error);
    }
  };

  const handleMonthUsersClick = async () => {
  try {
    const result = await userServices.fetchAllUsers(1);
    if (result?.users) {
      const count = usersAnalytics?.month || 10;
      setMonthUsers(result.users.slice(0, count));
    }
    setCurrentPage(1);
    setShowMonthUsersModal(true);
  } catch (error) {
    console.error("Error fetching month users:", error);
  }
};
  if (!dashboardData) {
    return (
      <>
        <div className="w-full flex justify-center items-center">
          <Loading />
        </div>
      </>
    );
  }

  const {
    usersAnalytics,
    proposalsAnalytics,
    chatAnalytics,
    premium,
    latest,
    genderDistribution,
    weekGenderDistribution,
  } = dashboardData;

  const filteredPremium = (premium || []).filter(
    (user) => !user.email || !user.email.toLowerCase().endsWith("@naseebimail.com")
  );

  const filteredLatest = (latest || []).filter(
    (user) => !user.email || !user.email.toLowerCase().endsWith("@naseebimail.com")
  );

  // Doughnut chart for gender
const genderData = {
  labels: ["Male", "Female"],
  datasets: [
    {
      label: "Gender Distribution",
      data: [genderDistribution.males, genderDistribution.females],
      backgroundColor: ["#FB565F", "black"],
    },
  ],
   
};

const options = {
  cutout: "70%", // default ~50%, zyada value = patli ring

};  


  // Weekly bar chart
  const weekLabels = weekGenderDistribution.map((d) => d.day);
  const maleData = weekGenderDistribution.map((d) => d.males);
  const femaleData = weekGenderDistribution.map((d) => d.females);

  const weeklyChart = {
    labels: weekLabels,
    datasets: [
      {
        label: "Male",
        data: maleData,
        backgroundColor: "#FB565F",
        borderRadius: 5,
      },
      {
        label: "Female",
        data: femaleData,
        backgroundColor: "black",
        borderRadius: 5,
      },
    ],
  };

  return (
    <>
      <div className={`rounded-xl w-full h-full min-h-[calc(100vh-120px)] overflow-x-hidden`}>
        {loading ? (
          <div className="flex justify-center items-center">
            <Loading />
          </div>
        ) : (
          <div className=" p-4 md:p-0">
            {/* Overview Section */}
            <div className="grid grid-cols-1 lg:grid-cols-[60%_40%] gap-4 mb-3">
              <div className="w-full bg-white md:rounded-xl md:shadow-md border-b-2 md:border-none">
                <div className="flex flex-col gap-3 py-6 px-4 h-full">
                  <div className="font-main font-semibold text-black text-left text-xl">
                    Overview 
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 text-center mt-2 px-3 h-full">
                    <div className="flex flex-col gap-3 p-4 rounded-xl bg-white border cursor-pointer hover:shadow-lg transition-shadow" onClick={handleTodayUsersClick}>
                      <div className="font-main text-black  font-[700] text-left">
                        Today Users
                      </div>
                      <div className="text-3xl text-left font-main text-gray-900 font-[600]">
                        {usersAnalytics.today}
                      </div>
                    </div>
                    <div className="flex flex-col gap-3 p-4 rounded-xl bg-white border cursor-pointer hover:shadow-lg transition-shadow" onClick={handleMonthUsersClick}>
                      <div className="text-black  font-[700]  font-main  text-left">
                        Monthly Users
                      </div>
                      <div className="font-main text-left text-3xl text-gray-900 font-[600]">
                        {usersAnalytics.month}
                      </div>
                    </div>
                    <div className="flex flex-col gap-3 p-4 rounded-xl bg-white border">
                      <div className="font-main text-black  font-[700] text-left">
                        Total Users
                      </div>
                      <div className="text-3xl text-left font-main text-gray-900 font-[600]">
                        {usersAnalytics.total}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Proposals & Chats summary */}
              <div className="md:w-1/2 md:rounded-xl md:shadow-md border-b-2 md:border-none">
                <div className="flex flex-col gap-3 py-6 px-4">
                  <div className="font-main font-semibold text-black text-left text-xl">
                    Proposals 
                  </div>
                  <div className=" text-center mt-2 px-3 h-full">
                    <div className="w-full flex flex-col gap-3 p-4 rounded-xl bg-white border">
                      <div className="font-main text-black  font-[700] text-left">
                        Total Proposals
                      </div>
                      <div className="text-3xl text-left font-main text-gray-900 font-[600]">
                        {proposalsAnalytics.total_proposals}
                      </div>
                    </div>
                  </div>
                      {/* Month Users Modal */}
                      {showMonthUsersModal && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                          <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto p-2 md:p-6 relative">
                            <button
                              className="absolute top-2 md:top-4 right-4 text-gray-500 hover:text-gray-700 text-md md:text-2xl font-bold"
                              onClick={() => setShowMonthUsersModal(false)}>
                              ✕
                            </button>

                            <h2 className="text-md md:text-2xl font-bold mb-6 text-black font-main">Monthly Users</h2>

                            {monthUsers.length > 0 ? (
                              <>
                                <div className="overflow-x-auto">
                                  <table className="w-full border-collapse text-xs md:text-sm border border-gray-300">
                                    <thead className="bg-gray-100">
                                      <tr>
                                        <th className="border border-gray-300 px-4 py-2 text-left font-semibold text-black font-main">First Name</th>
                                        <th className="border border-gray-300 px-4 py-2 text-left font-semibold text-black font-main">Last Name</th>
                                        <th className="border border-gray-300 px-4 py-2 text-left font-semibold text-black font-main">Email</th>
                                        <th className="border border-gray-300 px-4 py-2 text-left font-semibold text-black font-main">Contact Number</th>
                                        <th className="border border-gray-300 px-4 py-2 text-left font-semibold text-black font-main">Document Status</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {monthUsers
                                        .slice((currentPage - 1) * usersPerPage, currentPage * usersPerPage)
                                        .map((user, index) => (
                                          <tr key={index} className="hover:bg-gray-50 border-b border-gray-300">
                                            <td className="border border-gray-300 px-4 py-2 text-gray-700 font-main">{user.firstName}</td>
                                            <td className="border border-gray-300 px-4 py-2 text-gray-700 font-main">{user.lastName}</td>
                                            <td className="border border-gray-300 px-4 py-2 text-gray-700 font-main">{user.email}</td>
                                            <td className="border border-gray-300 px-4 py-2 text-gray-700 font-main">{user.contactNo || '-'}</td>
                                            <td className={`border border-gray-300 px-4 py-2 font-main font-semibold ${user.document === 'Not Uploaded' ? 'text-red-500' : 'text-green-500'}`}>{user.document || 'Not Uploaded'}</td>
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                </div>

                                {/* Pagination Controls */}
                                <div className="mt-6 flex justify-between items-center">
                                  <span className="text-xs text-sm text-gray-600 font-main">
                                    Page {currentPage} of {Math.ceil(monthUsers.length / usersPerPage)} | Total: {monthUsers.length} users
                                  </span>
                                  <div className="flex gap-2">
                                    <button
                                      onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                      disabled={currentPage === 1}
                                      className="px-2 md:px-4 py-2 bg-gray-300 text-gray-700 rounded text-xs text-sm hover:bg-gray-400 disabled:opacity-50 disabled:cursor-not-allowed font-main font-semibold">
                                      Previous
                                    </button>
                                    <button
                                      onClick={() =>
                                        setCurrentPage((prev) =>
                                          Math.min(prev + 1, Math.ceil(monthUsers.length / usersPerPage))
                                        )
                                      }
                                      disabled={currentPage === Math.ceil(monthUsers.length / usersPerPage)}
                                      className="px-2 md:px-4 py-2 bg-gray-300 text-gray-700 text-xs text-sm rounded hover:bg-gray-400 disabled:opacity-50 disabled:cursor-not-allowed font-main font-semibold">
                                      Next
                                    </button>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <p className="text-gray-500 text-center py-8 font-main">No users found</p>
                            )}

                            <div className="mt-6 flex justify-end">
                              <button
                                className="px-2 md:px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 font-main font-semibold"
                                onClick={() => setShowMonthUsersModal(false)}>
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                </div>
              </div>
            </div>

            {/* Charts */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-5">
              <div className="bg-white md:rounded-xl md:shadow-md p-5 border-b-2 md:border-none">
                <div className="font-main text-center font-semibold text-xl">
                  Users Distribution
                </div>
                <div className="mt-2 flex justify-center h-56 sm:h-64">
                {/* <div classNam  style={{ width: "310px", height: "310px" }}> */}
                  <Doughnut data={genderData} options={{ ...options, responsive: true, maintainAspectRatio: false }} />
                  {/* </div> */}
                </div>
              </div>
              <div className="font-main bg-white md:rounded-xl md:shadow-md p-5 lg:col-span-2 border-b-2 md:border-none">
                <div className="text-center font-main font-semibold text-xl">
                  Weekly Progress
                </div>
                <div className="mt-2 h-56 sm:h-64">
                  <Bar data={weeklyChart} options={{ responsive: true, maintainAspectRatio: false }} />
                </div>
              </div>
            </div>

            {/* Proposals & Chats Details */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 mt-5 mb-5">
  {/* ===== Daily Proposals ===== */}
  <div className="col-span-2 border-b-2  pb-6 md:border-none">
    <h2 className="text-lg font-main font-bold text-left text-black mb-3">
      Daily Proposals
    </h2>
    <div className="grid grid-cols-2 gap-4">
      {/* Sent */}
      <div className="flex flex-col p-4 gap-2 font-main shadow-md bg-white rounded-xl">
        <p className="text-gray-700 font-[500]">Sent Proposals</p>
        <p className="text-3xl font-bold">{proposalsAnalytics.today_proposals}</p>
      </div>
      {/* Accepted */}
      <div className="flex flex-col p-4 gap-2 font-main shadow-md bg-white rounded-xl">
        <p className="text-gray-700 font-[500]">Accepted Proposals</p>
        <p className="text-3xl font-bold">{proposalsAnalytics.today_accepted_proposals}</p>
      </div>
    </div>
  </div>

  {/* ===== Monthly Proposals ===== */}
  <div className="col-span-2 border-b-2  pb-6 md:border-none">
    <h2 className="text-lg font-main font-bold text-left text-black mb-3">
      Monthly Proposals
    </h2>
    <div className="grid grid-cols-2 gap-4">
      {/* Sent */}
      <div className="flex flex-col p-4 gap-2 font-main shadow-md bg-white rounded-xl">
        <p className="text-gray-700 font-[500]">Sent Proposals</p>
        <p className="text-3xl font-bold">{proposalsAnalytics.month_proposals}</p>
      </div>
      {/* Accepted */}
      <div className="flex flex-col p-4 gap-2 font-main shadow-md bg-white rounded-xl">
        <p className="text-gray-700 font-[500]">Accepted Proposals</p>
        <p className="text-3xl font-bold">{proposalsAnalytics.month_accepted_proposals}</p>
      </div>
    </div>
  </div>

  {/* ===== Daily Chats ===== */}
  {/* <div>
    <h2 className="text-lg font-main font-bold text-left text-black mb-3">
      Daily Chats
    </h2>
    <div className="flex flex-col p-4 gap-2 font-main shadow-md bg-white rounded-xl">
      <p className="text-gray-700 font-[500]">Today</p>
      <p className="text-3xl font-bold">{chatAnalytics.today}</p>
    </div>
  </div>

  <div>
    <h2 className="text-lg font-main font-bold text-left text-black mb-3">
      Monthly Chats
    </h2>
    <div className="flex flex-col p-4 gap-2 font-main shadow-md bg-white rounded-xl">
      <p className="text-gray-700 font-[500]">Monthly</p>
      <p className="text-3xl font-bold">{chatAnalytics.month}</p>
    </div>
  </div> */}

</div>


            {/* Premium & Latest Users */}
            <div className="w-full gap-4 md:gap-6 lg:gap-4 flex flex-col md:flex-row justify-between col-span-1 lg:col-span-2 md:bg-white rounded-xl md:shadow-lg p-0 md:p-4 ">
              <div className="w-full md:w-1/2 rounded-lg p-0 md:p-4 md:shadow-md md:border md:border-black-600 ">
                <h2 className="font-main text-lg font-semibold text-red-500  pb-2 mb-4">
                  Premium Users
                </h2>

                {filteredPremium?.length > 0 ? (
                  <div className="overflow-x-auto md:overflow-visible">
                    <table className="min-w-[640px] md:min-w-full border border-gray-200 rounded-lg text-xs sm:text-sm">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="font-main md:px-4 py-2 text-left text-sm text-black  font-[700]">
                            First Name
                          </th>
                          <th className="font-main md:px-4 py-2 text-left text-sm text-black  font-[700]">
                            Last Name
                          </th>
                          <th className="font-main md:px-4 py-2 text-left text-sm text-black  font-[700]">
                            Email
                          </th>
                          <th className="font-main md:px-4 py-2 text-left text-sm text-black  font-[700]">
                            Gender
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredPremium.map((user, index) => (
                          <tr
                            key={index}
                            className="font-main hover:bg-green-50 border-t border-gray-200"
                          >
                            <td className="font-main px-1 md:px-4 py-2 text-sm text-gray-700">
                              {user.firstName}
                            </td>
                            <td className="font-main px-1 md:px-4 py-2 text-sm text-gray-700">
                              {user.lastName}
                            </td>
                            <td className="font-main px-1 md:px-4 py-2 text-sm text-gray-700">
                              {user.email}
                            </td>
                            <td className="font-main px-1 md:px-4 py-2 text-sm text-gray-700">
                              {user.gender}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-gray-500 text-sm font-main ">
                    No premium users found
                  </p>
                )}
              </div>

              <div className="w-full md:w-1/2 rounded-lg p-0 md:p-4 md:shadow-md md:border md:border-black-600 ">
                <h2 className="font-main text-lg text-red-500 font-semibold  pb-2 mb-4 ">
                  Latest Users (Top 10)
                </h2>

                {filteredLatest?.length > 0 ? (
                  <div className="overflow-x-auto md:overflow-visible">
                    <table className="min-w-[640px] md:min-w-full border border-gray-200 rounded-lg text-xs sm:text-sm">
                      <thead className="font-main bg-gray-100">
                        <tr>
                          <th className="font-main px-4 py-2 text-left text-sm text-black  font-[700]">
                            First Name
                          </th>
                          <th className="font-main px-4 py-2 text-left text-sm text-black  font-[700]">
                            Last Name
                          </th>
                          <th className="font-main px-4 py-2 text-left text-sm text-black  font-[700]">
                            Email
                          </th>
                          <th className="font-main px-4 py-2 text-left text-sm text-black  font-[700]">
                            Gender
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredLatest.map((user, index) => (
                          <tr
                            key={index}
                            className="font-main hover:bg-blue-50 border-t border-gray-200"
                          >
                            <td className="font-main px-4 py-2 text-sm text-gray-700">
                              {user.firstName}
                            </td>
                            <td className="font-main px-4 py-2 text-sm text-gray-700">
                              {user.lastName}
                            </td>
                            <td className="font-main px-4 py-2 text-sm text-gray-700">
                              {user.email}
                            </td>
                            <td className="font-main px-4 py-2 text-sm text-gray-700">
                              {user.gender}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-gray-500 text-sm font-main">
                    No latest users found
                  </p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Today Users Modal */}
      {showTodayUsersModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto p-2 md:p-6 relative">
            <button
              className="absolute top-2 right-4 text-gray-500 hover:text-gray-700 text-lg md:text-2xl font-bold"
              onClick={() => setShowTodayUsersModal(false)}>
              ✕
            </button>

            <h2 className=" text-lg md:text-2xl font-bold mb-3 md:mb-6 text-black font-main">Today Users</h2>

            {todayUsers.length > 0 ? (
              <>
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse text-xs md:text-sm border border-gray-300">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="border border-gray-300 px-2 md:px-4 py-2 text-left font-semibold text-black font-main">First Name</th>
                        <th className="border border-gray-300 px-2 md:px-4 py-2 text-left font-semibold text-black font-main">Last Name</th>
                        <th className="border border-gray-300 px-2 md:px-4 py-2 text-left font-semibold text-black font-main">Email</th>
                        <th className="border border-gray-300 px-2 md:px-4 py-2 text-left font-semibold text-black font-main">Contact Number</th>
                        <th className="border border-gray-300 px-2 md:px-4 py-2 text-left font-semibold text-black font-main">Document Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {todayUsers
                        .slice((currentPage - 1) * usersPerPage, currentPage * usersPerPage)
                        .map((user, index) => (
                          <tr key={index} className="hover:bg-gray-50 border-b border-gray-300">
                            <td className="border border-gray-300 px-4 py-2 text-gray-700 font-main">{user.firstName}</td>
                            <td className="border border-gray-300 px-4 py-2 text-gray-700 font-main">{user.lastName}</td>
                            <td className="border border-gray-300 px-4 py-2 text-gray-700 font-main">{user.email}</td>
                            <td className="border border-gray-300 px-4 py-2 text-gray-700 font-main">{user.contactNo || '-'}</td>
                            <td className={`border border-gray-300 px-4 py-2 font-main font-semibold ${user.document === 'Not Uploaded' ? 'text-red-500' : 'text-green-500'}`}>{user.document || 'Not Uploaded'}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination Controls */}
                <div className="mt-6 flex justify-between items-center">
                  <span className="text-xs md:text-sm text-gray-600 font-main">
                    Page {currentPage} of {Math.ceil(todayUsers.length / usersPerPage)} | Total: {todayUsers.length} users
                  </span>
                  <div className="flex gap-2">
                    <button
                      onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                      disabled={currentPage === 1}
                      className="text-xs md:text-sm px-2 md:px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 disabled:opacity-50 disabled:cursor-not-allowed font-main font-semibold">
                      Previous
                    </button>
                    <button
                      onClick={() =>
                        setCurrentPage((prev) =>
                          Math.min(prev + 1, Math.ceil(todayUsers.length / usersPerPage))
                        )
                      }
                      disabled={currentPage === Math.ceil(todayUsers.length / usersPerPage)}
                      className="text-xs md:text-sm px-2 md:px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 disabled:opacity-50 disabled:cursor-not-allowed font-main font-semibold">
                      Next
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <p className="text-gray-500 text-center py-8 font-main">No users found</p>
            )}

            <div className="mt-6 flex justify-end">
              <button
                className="text-xs md:text-sm px-4 md:px-6 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 font-main font-semibold"
                onClick={() => setShowTodayUsersModal(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
